export function createGroupedXAxisYearPlugin({
  id = "groupedXAxisYear",
}: {
  id?: string;
}) {
  return {
    id,
    afterDraw(chart: any) {
      const { ctx, scales } = chart;
      const xScale = scales.x;
      const labels: string[] = chart.data.labels;

      if (!labels || labels.length === 0) return;

      const yearLabelY = xScale.bottom + 6;
      ctx.save();
      ctx.font = "400 12px 'Graphik Web'";
      ctx.textAlign = "center";
      ctx.fillStyle = "#6C757D"; // muted text

      let lastYear: string | null = null;
      let startX = null;
      let endX = null;

      for (let i = 0; i < labels.length; i++) {
        const label = labels[i];
        const parts = label.split(" ");
        if (parts.length < 2) continue;

        const year = parts[1];
        const labelX = xScale.getPixelForValue(label as unknown as number);

        if (year !== lastYear) {
          // Draw previous year
          if (lastYear && startX !== null && endX !== null) {
            const midX = (startX + endX) / 2;
            ctx.fillText(lastYear, midX, yearLabelY);
          }

          // Start new year group
          lastYear = year;
          startX = labelX;
        }

        endX = labelX;
      }

      // Draw final year
      if (lastYear && startX !== null && endX !== null) {
        const midX = (startX + endX) / 2;
        ctx.fillText(lastYear, midX, yearLabelY);
      }

      ctx.restore();
    },
  };
}
